import { COLORS } from '@/constants';
import { Button } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px;
  border-radius: 6px;
  border: 1px solid ${COLORS['neutral/300']};
  // width: 100%;
`;

export const FilterFieldsList = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
  max-width: 350px;
  overflow-x: auto;
  margin-bottom: -6px;
  padding-bottom: 10px;

  scrollbar-width: thin;

  @-moz-document url-prefix() {
    scrollbar-width: auto;
    scrollbar-gutter: stable;
  }
`;

export const FilterField = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  padding: 8px 10px;
  border-radius: 4px;
  background: ${COLORS['neutral/50']};
`;

export const BtnBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  margin-left: auto;
`;

export const StyledButton = styled(Button)`
  && {
    border-radius: 4px;
    border: 1px solid ${COLORS['neutral/300']};
    color: ${COLORS['neutral/300']};
    width: 34px;
    height: 34px;
  }
`;

export const ProjectBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  background: ${COLORS['primary/50']};
  color: ${COLORS['primary/600']};
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;
  flex-shrink: 0;
`;
